import type { AppLolRegion, AppRegion } from "@core-types/region.enum";
import LolRegionHelper from "@helpers/regions/LolRegionHelper";
import { EBreakpoints, useBreakpoint } from "@hooks/useBreakpoint";
import { Group } from "@mantine/core";
import useRegionStore, { getRegion } from "@store/region.store";
import { useEffect } from "react";
import RegionSkinProductSelect from "../select/RegionSkinProductSelect";
import RegionButton from "./RegionButton";

interface IRegionSelectorBannerProps {
  className?: string;
  onRegionChange?: (region: AppLolRegion) => void;
}

export const LOL_GRADIENT = { from: "#5943DE", to: "#B062FE" };

const LolRegionSelectorBanner: React.FC<IRegionSelectorBannerProps> = ({
  className,
  onRegionChange,
}) => {
  const { setRegion, region } = useRegionStore();
  const regions = LolRegionHelper.getAllInfo();
  const storeRegion = getRegion();
  const { breakpoint } = useBreakpoint();

  const handleChangeRegion = (region: AppRegion) => {
    setRegion(region);
  };

  /* Don't specify onRegionChange to avoid infinite loop */
  useEffect(() => {
    // We only want to trigger onRegionChange when the region actually changes
    // from user interaction, not on initial mount which can cause redirect loops.
    onRegionChange?.(region as AppLolRegion);
  }, [region]);

  if (breakpoint > EBreakpoints.MD)
    return (
      <Group className={`ml-11 ${className}`}>
        {regions.map((region) => (
          <RegionButton
            key={region.code}
            region={region}
            isSelected={region.code === storeRegion}
            onClick={handleChangeRegion}
            gradientVariant={LOL_GRADIENT}
            icon={region.whiteImage}
          />
        ))}
      </Group>
    );

  return (
    <div className="ml-1 xs:ml-12 max-w-[320px]">
      <RegionSkinProductSelect
        region={region}
        regions={regions}
        onRegionChange={handleChangeRegion}
      />
    </div>
  );
};

export default LolRegionSelectorBanner;
